import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconRemoveSign = props => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path d="m9 9h-4v2h4 2 4v-2h-4-2zm1-9c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
  </SvgIcon>
);

export default IconRemoveSign;



// WEBPACK FOOTER //
// ./src/components/icons/IconRemoveSign.js